import React from 'react';
import PropTypes from 'prop-types';
import {useTranslation} from 'react-i18next';
import DetailsTable from '../../TransactionsPage/DetailsTable';
import {objectHelpers} from '../../../../utils/helpers';

const VendorBankDetails = ({
  vendor,
  ...rest
}) => {
  const [t] = useTranslation('main');

  const getObjProp = (key, defaultValue = '-') => objectHelpers.getObjProp(vendor, key, defaultValue);

  const data = [
    {
      key: 'iban',
      label: t('iban'),
      value: getObjProp('iban')
    },
    {
      key: 'bic',
      label: t('bic/swift'),
      value: getObjProp('bic')
    }
  ]

  return (
    <DetailsTable
      {...rest}
      data={data}
    />
  );
}

VendorBankDetails.propTypes = {
  vendor: PropTypes.shape({
    bic: PropTypes.string,
    iban: PropTypes.string,
  }),
}

export default VendorBankDetails;
